import { render, staticRenderFns } from "./index.vue?vue&type=template&id=700285e9"
import script from "./ternimationNotice.js?vue&type=script&lang=js&external"
export * from "./ternimationNotice.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports